import React, { useEffect, useState } from "react";
import { faCartShopping, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Cart.css";
import { Button } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import CartProductCard from "./cart_product_card/CartProductCard";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import Payment_Summary from "./payment_summary/Payment_Summary";
import Similar_Products from "../product_description/similar_products/Similar_Products";
import Cart_Similar_Products from "./cart_similar_products/Cart_Similar_Products";
import Special_Instructions_Modal from "../common_components/common_modal/Special_Instructions_Modal/Special_Instructions_Modal";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../features/cart/cartSlice";
import { appSetup } from "../../features/master/masterSlice";
import { getAllProducts } from "../../features/products/productsSlice";
import { OrderCalculation } from "../../features/order/orderSlice";

const Cart = ({ setDeliveryNote, deliveryNote, ...props }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [totalSaving, setTotalSaving] = useState();
  const [totaAmount, setTotalAmount] = useState();
  const [count, setCount] = useState();

  const cart = useSelector((state) => state.cart.allCarts);

  useEffect(() => {
    dispatch(getAllCart(props?.isSignIn));
  }, []);

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, []);

  const [modalShow, setModalShow] = useState(false);

  const parts = [
    props?.orderAddress?.building,
    props?.orderAddress?.street,
    props?.orderAddress?.apartment,
    props?.orderAddress?.Users_Address_Detail?.Country?.name,
    props?.orderAddress?.Users_Address_Detail?.State?.name,
    props?.orderAddress?.Users_Address_Detail?.City?.name,
    props?.orderAddress?.Users_Address_Detail?.Pincode?.name,
  ];
  const saveTotal = (cart) => {
    let total = 0;
    let selling = 0;
    let mrp_data = 0;
    let selling_price = 0;
    let count = 0;
    let tax = 0;
    let cess = 0;

    if (cart?.data?.data?.length > 0) {
      for (const element of cart?.data?.data) {
        // const price = Number(
        //   element?.Product_Variant?.price -
        //     (element?.Product_Variant?.price *
        //       (element?.Product?.tax_percentage / 100) +
        //       element?.Product_Variant?.price *
        //         (element?.Product?.cess_percentage / 100))
        // );

        const taxPercentage = element?.Product?.tax_percentage ?? 0;
        const cessPercentage = element?.Product?.cess_percentage ?? 0;
        const taxper = Number(taxPercentage) + Number(cessPercentage);
        const qty = Number(element.quantity);
        const price = Number(
          element?.Product_Variant?.price / (1 + taxper / 100)
        ).toFixed(2);

        const mrp = Number(
          element?.Product_Variant?.mrp / (1 + taxper / 100)
        ).toFixed(2);

        const sellingprice = Number(element?.Product_Variant?.price).toFixed();
        const mrpdata = Number(element?.Product_Variant?.mrp).toFixed();

        selling_price += sellingprice * qty;
        mrp_data += mrpdata * qty;
        total += mrp * qty;
        tax +=
          (price * qty * Number(element?.Product?.tax_percentage || 0)) / 100;
        cess +=
          (price * qty * Number(element?.Product?.cess_percentage || 0)) / 100;
        selling += price * qty;
        count += 1;
        setTotalAmount(total);
        setTotalSaving(selling);
        setCount(count);
      }
    }
    const data = {
      total_mrp: Number(total).toFixed(2),
      total_mrp_gst: Number(mrp_data).toFixed(2),
      total_selling_price_gst: Number(selling_price).toFixed(2),
      total_tax: Number(tax).toFixed(2),
      no_of_item: count,
      total_cess: Number(cess).toFixed(2),
      total_selling_price: Number(selling).toFixed(2),
      total_amount: selling + tax + cess,
    };
    return data;
  };
  const [data, setData] = useState();

  useEffect(() => {
    const data = saveTotal(cart);
    setData(data);
  }, [cart]);

  const allSimilarProducts = useSelector((state) => state.product.allProducts);
  useEffect(() => {
    if (cart?.data?.data?.length > 0) {
      dispatch(
        getAllProducts({
          category_id: cart?.data?.data[0]?.Product?.p_category_id,
          subcategory_id: cart?.data?.data[0]?.Product?.p_sub_category_id,
          childcategory_id: cart?.data?.data[0]?.Product?.p_child_category_id,
        })
      );
    }
  }, [dispatch, cart]);

  const [canProceed, setCanProceed] = useState("");

  useEffect(() => {
    if (cart?.data?.data?.length > 0) {
      const hasUnavailable = cart?.data?.data.some((val) => {
        const stock = Number(val?.Product_Variant?.general_stock ?? 0);
        const quantity = Number(val?.quantity ?? 0);
        const isOutOfStock = stock < quantity;

        const isDeleted = val?.Product?.deletedAt !== null;

        return isOutOfStock || isDeleted; // If either condition is true
      });

      if (hasUnavailable) {
        setCanProceed(
          "Some products in your cart are unavailable . Please update your cart before proceeding to payment."
        );
      } else {
        setCanProceed(""); // No error message
      }
    }
  }, [cart]);

  const [paymentData, setPaymentData] = useState({});
  const orderCalculation = async (addressId) => {
    // const fallbackAddressId =
    //   Array.isArray(allAddress?.data) && allAddress?.data.length > 0
    //     ? allAddress.data[0].id
    //     : null;

    const data = {
      // address_id: props?.addressId || fallbackAddressId,
    };

    const res = await dispatch(OrderCalculation(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setPaymentData(res?.payload?.data);
    } else if (res.meta?.requestStatus === "rejected") {
      // handle error
    }
  };

  useEffect(() => {
    orderCalculation();
  }, []);

  return (
    <section className="Cart">
      <Breadcrumb_comp
        breadcrumbs={[
          { label: "Home", link: "/", isActive: false },
          { label: "cart", link: "", isActive: true },
        ]}
        additionalClass="groceries "
      />

      <div className="container ">
        <div className="cart_main_container">
          <div className="data_holder">
            {cart?.data?.data?.length > 0 ? (
              <div className="row">
                <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                  <div className="left_side_card">
                    {cart.data.data.map((item, index) => {
                      const isDeleted = item?.Product?.deletedAt !== null;
                      const isOutOfStock =
                        (item?.Product_Variant?.general_stock ?? 0) <= 0;

                      return (
                        <div className="product_card_section" key={index}>
                          {/* Product Card */}
                          <CartProductCard
                            title={item?.Product?.name}
                            footer_text_color="#6EC090"
                            img={item?.Product?.image}
                            orderId="Order ID #675843"
                            items="2 Items"
                            kwd="Rs.: 200"
                            footer_text="Delivering in 10 mins"
                            date="27th Oct. | 03:28 pm"
                            customClass={""}
                            cartVarient={item}
                            saveTotal={saveTotal}
                          />

                          {/* Error for this specific product */}
                          {(isDeleted || isOutOfStock) && (
                            <div
                              style={{
                                color: "red",
                                fontWeight: "bold",
                                marginTop: "5px",
                                fontSize: "14px",
                                backgroundColor: "#ffe5e5",
                                padding: "5px",
                                borderRadius: "4px",
                              }}
                            >
                              ❌{" "}
                              {isDeleted
                                ? "This product is not available."
                                : "This product is out of stock."}
                            </div>
                          )}
                        </div>
                      );
                    })}

                    <div
                      className="delivery_note_div"
                      onClick={() => setModalShow(true)}
                    >
                      <div className="">
                        <p className="delivery_note">
                          Delivery Note (Optional)
                        </p>
                      </div>

                      <div className="">
                        <FontAwesomeIcon icon={faPlus} className="plus_icon" />
                      </div>
                    </div>
                    {allSimilarProducts?.length > 0 && (
                      <div className="cart_similar_prods">
                        <Cart_Similar_Products product={allSimilarProducts} />
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                  <Payment_Summary
                    show={true}
                    canProceed={canProceed}
                    cart={cart}
                    app_setup={app_setup}
                    data={data}
                    parts={parts}
                  />
                </div>
              </div>
            ) : (
              <div
                className="empty_cart"
                style={{
                  textAlign: "center",
                  padding: "20px",
                  fontWeight: "bold",
                  fontSize: "40px",
                }}
              >
                🛒
                <p style={{ fontSize: "20px", margin: "10px 0 0" }}>
                  Your cart is empty
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Special_Instructions_Modal
        deliveryNote={deliveryNote}
        setDeliveryNote={setDeliveryNote}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default Cart;
